import $ from "jquery";

export const getStyle = function (obj, attr) {
    var ie = !+"\v1"; //简单判断ie6~8
    if (attr == "backgroundPosition") {
      //IE6~8不兼容backgroundPosition写法，识别backgroundPositionX/Y
      if (ie) {
        return (
          obj.currentStyle.backgroundPositionX +
          " " +
          obj.currentStyle.backgroundPositionY
        );
      }
    }
    if (obj.currentStyle) {
      return obj.currentStyle[attr];
    } else {
      return document.defaultView.getComputedStyle(obj, null)[attr];
    }
  }

export const oset = (obj, path, value) => {
    try {
        var error = false;
        const pathArr = path.split(".") || [];
        var _obj = obj;
        const length = pathArr.length;
        pathArr.forEach((name, i) => {

            if (error) return;
            const end = i === length - 1;

            switch (true) {

                // 普通字段赋值
                case !name.includes("[") && !name.includes("]"):
                    // 判断属性是否存在，不存在则创建
                    if (end) return _obj[name] = value;
                    if (_obj[name] === undefined) _obj[name] = {};
                    _obj = _obj[name];
                    break;

                case name.includes("[") && name.includes("]"):
                    const option = name.split("[");
                    const filed = option[0];
                    const index = option[1].replace("]", "");
                    // 是否有属性（"a[0]"）
                    const hasFiled = filed !== "";

                    // 如果数组不存在则抛出错误
                    if (hasFiled && (!_obj[filed] || !_obj[filed][index])) {
                        error = true;
                        console.error("要赋值的数组不存在 或 指定的下标不存在！");
                        console.error(obj, path, value);
                        return;
                    }
                    if (!hasFiled && !_obj[index]) {
                        error = true;
                        console.error("要赋值的数组不存在 或 指定的下标不存在！");
                        console.error(obj, path, value);
                        return;
                    }

                    if (hasFiled && end) return _obj[filed][index] = value;
                    if (!hasFiled && end) return _obj[index] = value;
                    _obj = hasFiled ? _obj[filed][index] : _obj[index];
                    break;

                default:
                    break;
            }
        })

    } catch (error) {
        console.error("赋值异常：", error);
        console.error(obj, path, value);
    }
}

export const oget = (obj, path) => {
    if (!path) return undefined;
    let value = undefined;
    try {
        var error = false;
        const pathArr = path.split(".") || [];
        var _obj = obj;
        const length = pathArr.length;
        pathArr.forEach((name, i) => {

            if (error) return;
            const end = i === length - 1;

            switch (true) {

                // 普通字段赋值
                case !name.includes("[") && !name.includes("]"):
                    // 判断属性是否存在，不存在则创建
                    if (end) return value = _obj[name];
                    if (_obj[name] === undefined) _obj[name] = {};
                    _obj = _obj[name];
                    break;

                case name.includes("[") && name.includes("]"):
                    const option = name.split("[");
                    const filed = option[0];
                    const index = option[1].replace("]", "");
                    // 是否有属性（"a[0]"）
                    const hasFiled = filed !== "";

                    // 如果数组不存在则抛出错误
                    if (hasFiled && (!_obj[filed] || !_obj[filed][index])) {
                        error = true;
                        console.error("要获取的数组不存在 或 指定的下标不存在！");
                        console.error(obj, path, value);
                        return;
                    }
                    if (!hasFiled && !_obj[index]) {
                        error = true;
                        console.error("要获取的数组不存在 或 指定的下标不存在！");
                        console.error(obj, path, value);
                        return;
                    }

                    if (hasFiled && end) return value = _obj[filed][index];
                    if (!hasFiled && end) return value = _obj[index];
                    _obj = hasFiled ? _obj[filed][index] : _obj[index];
                    break;

                default:
                    break;
            }
        });
    } catch (error) {
        console.warn("数据源不存在：", path);
    }
    return value;
}

/**
 * 返回对象中指定的多个属性
 * @param {Object} obj 对象
 * @param {Array} paths 获取的字段名称序列
 * @returns 获取到的字段序列
 */
export const ogets = (obj, paths) => {
    return paths.map(val => oget(obj, val));
}

/**
 * 删除字符串中的空格
 * @param {String} str 字符串
 */
export const removeSpaces = str => {
    return str.replace(/\s+/g, "");
}

export const deepCopyJson = o => JSON.parse(JSON.stringify(o));
export const deepCopy = (obj) => {
    var result = Array.isArray(obj) ? [] : {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object' && obj[key] != null) {
                result[key] = deepCopy(obj[key]);   //递归复制
            } else {
                result[key] = obj[key];
            }
        }
    }
    return result;
}

/**
* 循环执行一个函数，当函数返通过或者超出最大限时后执行下面的操作
* @param {Function} judge 判断函数
* @param {Function} handler 执行函数
* @param {Number} space 判断间隔
* @param {Number} maxDuration 最大时长
*/
export const loopJudgeDoSomething = ({ judge, handler, timeout, space = 100, maxDuration = 2000 }) => {
    // if (judge()) return handler();
    var duration = 100;
    var timer = setTimeout(toJudge, space);
    async function toJudge() {
        const result = await judge();
        const status = typeof result === "object" ? result.status : result;
        if (status) {
            clearTimeout(timer);
            handler(result);
        } else if (duration >= maxDuration && timeout) {
            timeout();
        } else {
            duration += space;
            timer = setTimeout(toJudge, space);
        }
    }
}

/**
* @description 获取地址栏的参数
* @param { String } name 参数名称
*/
export const getUrlParam = name => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r !== null) return decodeURI(r[2]); return null;
}

/**
 * @description 函数节流
 * @param { Function } method
 * @param { Number } delay
 * @returns { Function }
 * @example window.onresize = debounce(resizehandler, 200);
 */
export const debounce = (method, delay = 200) => {
    var timer = null;
    return function () {
        var self = this, args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => method.apply(self, args), delay);
    }
}

/**
 * @description 生成一个指定位数的随机字符串
 * @param { Number } length 参数名称
 */
export const getRandomStr = (length = 32) => {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    var nums = "";
    for (var i = 0; i < length; i++) {
        var id = parseInt(Math.random() * 61);
        nums += chars[id];
    }
    return nums;
}
/**
 * 图片转 base64
 * @param {File} img 图片对象
 */
export const getBase64Sync = (img) => {
    return new Promise(function (resolve) {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result));
        reader.readAsDataURL(img);
    });
}
/**
 * 同步获取 base64 格式图片的宽高
 * @param {String} base64
 */
export const base64ToImage = (base64, callback) => {
    var img = new Image();
    img.src = base64;
    img.onload = () => {
        callback(img);
    }
}

/**
 *
 */
export const fileType = name => {
    switch (true) {

        case ["jpg", "jpeg", "gif", "png"].includes(name):
            return "img";

        case ["avi", "mov", "asf", "wmv", "nvai", "mov", "mp4", "flv"].includes(name):
            return "video";

        case ["mp3"].includes(name):
            return "audio";

        default:
            break;
    }
}
/**
 * 对比旧的对象，并返回用于后续对比发函数
 * @param {Object} obj 将要发生改变的对象
 */
export const contrastOldObject = (obj) => {
    // 深拷贝（很骚的写法）
    let old = JSON.parse(JSON.stringify(obj));
    /**
     * 对比函数
     * @param {Object} newobj 改变后的对象
     * @param {Array} must 必须要包含的属性（即使没有发生变化也需要包含在返回对象中）
     * @param {Boolean} status 是否返回变更状态
     */
    return function (newobj, must = [], status = false) {
        let update = {};

        // 先将必要的参数存入
        if (must.length > 0) must.map(val => {
            const path = val.split(".");
            // 确保赋值是对象不为 undefined
            mustContrast(path, update, newobj);
            const value = oget(newobj, val);
            oset(update, val, value);
        });

        const mustJson = JSON.stringify(update);

        function mustContrast(path, container, newobj) {
            function start(item, index) {
                if (!newobj[item]) console.error("期望的必要参数不存在：", path.join("."), item);
                if (!container[item]) container[item] = {};
                index++;
                if (index < path.length) start(index, index);
            }
            start(path[0], 0);
        }

        // 递归对比函数
        function contrast(container, obj, old) {
            const keys = Object.keys(obj);
            keys.forEach(key => {
                if (must.includes(key)) return;
                // 新对象的值
                const newValue = obj[key];
                // 如果是对象，向下比对
                if (Array.isArray(newValue)) {
                    if (JSON.stringify(newValue) !== JSON.stringify(old[key])) container[key] = newValue;
                } else if (typeof newValue === "object" && newValue) {
                    // 如果不存在，赋值空对象
                    if (!container[key]) container[key] = {}
                    // 如果旧对象中没有这个属性
                    if (old[key] === undefined) {
                        container[key] = newValue;
                        return;
                    }
                    // 得到判断结果
                    let result = contrast(container[key], newValue, old[key]);
                    // 如果是空对象代表没有更改，删掉这个属性
                    if (JSON.stringify(result) === "{}") delete container[key];
                } else if ((old[key] === undefined && newValue !== undefined) || newValue !== old[key]) container[key] = newValue;
            })
            return container;
        }

        contrast(update, newobj, old);
        // 不知道哪里多出来了一个 1，先手动删掉
        if (update["1"]) delete update["1"];
        return status ? {
            vo: update,
            isUpdate: !(JSON.stringify(update) === mustJson)
        } : update;
    }
}
export const setWXTitle = title => {
    title = decodeURIComponent(title)
    document.title = title;
    var $body = $('body');
    var $iframe = $('<iframe src="/favicon.ico"></iframe>');
    $iframe.on('load', function () {
        setTimeout(function () {
            $iframe.off('load').remove();
        }, 0);
    }).appendTo($body);
}
export const decodeUTF8 = (arr = []) => {
    if (!arr.length) return "";
    let str = arr.reduce((prev, cur) => prev += `%${cur.toString(16)}`, '')
    return decodeURIComponent(str)
}

export const arr2Dic = function (arr = [], field, other) {
    let dic = {};
    if (Array.isArray(field)) {
        arr.forEach(vo => {
            dic[vo[field[0]]] = other ? Object.assign(vo, deepCopy(other)) : vo[field[1]];
        })
    } else {
        arr.forEach(vo => {
            dic[vo[field]] = other ? Object.assign(vo, deepCopy(other)) : vo;
        })
    }
    return dic;
}

/**
 * jquery dom 数组 转真数组
 * @param {JqueryList} $list jquery dom 数组
 */
export function jqueryToArray($list) {
    let arr = [];
    $list.map((i, val) => arr.push(val));
    return arr;
}

/**
* 间隔处理数组种的项
* @param {Array} arr 要处理的数组
* @param {Function} func 处理函数
* @param {Number} duration 间隔毫秒
* @param {Boolean} async 同步执行
*/
export function mapDelayed(arr, func, duration, async = true) {

    // 初始化任务列表
    const tasks = arr.map(val => () => func(val));

    // 为 number 标识任务间隔相同
    if (typeof duration === "number") {
        const timer = setInterval(() => {
            const fn = tasks.next();
            if (fn) fn();
            if (tasks.onLast()) clearInterval(timer);
        }, duration);
    }

    // 为 Array 代表任务间隔不同
    if (Array.isArray(duration)) {

        // 异步执行各个操作
        // if (!async) while(tasks.hasNext()) {
        //     let fn = tasks.next();
        //     let timer = setTimeout(() => {
        //         if (fn) fn();
        //         clearTimeout(timer);
        //     }, duration.next())

        // // 同步执行
        // } else {
        //     let next = () => {
        //         let fn = tasks.next();
        //         const timer = setTimeout(() => {
        //             if (fn) fn();
        //             clearTimeout(timer);
        //             if (tasks.hasNext()) next();
        //         }, duration.next())
        //     }
        //     if (tasks.hasNext()) next();
        //     // 因为 next 创建了闭包所以需要释放
        //     else next = null;
        // }
    }
}

/**
 * 在一段持续调用中，先执行一个开始函数，当持续调用结束后执行结束函数
 * @param {*} startFun 开始函数
 * @param {Function} endFun 结束函数
 * @param {Number} delay 间隔时间
 */
export function headTail(startFun, endFun, delay = 200) {
    var timer = null;
    return function () {
        var self = this, args = arguments;
        if (!timer) startFun.apply(self, args);
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            endFun.apply(self, args);
            clearTimeout(timer);
            timer = null;
        }, delay);
    }
}
export const changeFavicon = link => {
    let $favicon = document.querySelector('link[rel="icon"]');
    // If a <link rel="icon"> element already exists,
    // change its href to the given link.
    if ($favicon !== null) {
        $favicon.href = link;
        // Otherwise, create a new element and append it to <head>.
    } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
    }
};

export const toArr = function (str) {
    if (!str) return [];
    if (typeof str === "string")
        return str.split(",")
    return str;
}
export const isWindows = function () {
    return /windows|win32/i.test(navigator.userAgent);
}

export const IEVersion = function () {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion === 7) {
            return 7;
        } else if (fIEVersion === 8) {
            return 8;
        } else if (fIEVersion === 9) {
            return 9;
        } else if (fIEVersion === 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if (isEdge) {
        return 'edge';//edge
    } else if (isIE11) {
        return 11; //IE11
    } else {
        return false;//不是ie浏览器
    }
}